<template>
	<div class="pageContainer app-container studentContainer">
		<el-row>
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">

				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="考试证号" value="exam_num">考试证号</el-option>
			</el-select>


			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
				style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />
				<span style="font-size: 14px;">通过状态：</span>
				<el-select v-model="searchForm.confirm" size="small" placeholder="请选择"
					style="width: 100px; margin-right: 10px;">
				
					<el-option label="全部" value="">全部</el-option>
					<el-option label="未审核" :value="0">未审核</el-option>
					<el-option label="已通过" :value="1">已通过</el-option>
					<el-option label="不通过" :value="2">不通过</el-option>
					
				</el-select>
			<span style="font-size: 14px;">状态：</span>
			<el-select v-model="searchForm.is_pub" size="small" placeholder="请选择"
				style="width: 100px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option label="未发布" :value="0">未发布</el-option>
				<el-option label="已发布" :value="1">已发布</el-option>
				
			</el-select>
			<span style="font-size: 14px;">专业：</span>
			<el-select v-model="searchForm.major_id" size="small" placeholder="请选择"
				style="width: 150px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option v-for="(d,i) in majorList" :key="i" :label="d.title" :value="d.id"></el-option>

			</el-select>
			<span style="font-size: 14px;">性别：</span>
			<el-select v-model="searchForm.gender" size="small" placeholder="请选择"
				style="width: 80px; margin-right: 10px;">

				<el-option label="全部" value="">全部</el-option>
				<el-option label="男" :value="1">男</el-option>
				<el-option label="女" :value="2">女</el-option>

			</el-select>


			<el-button size="small" icon="el-icon-search" @click="getList" plain type="primary">查询</el-button>

			<el-button size="small" icon="el-icon-check" @click="checkList" plain type="primary">检查通过列表</el-button>



		</el-row>
		<el-row style="margin-top: 20px">


			<el-tabs v-model="activeName" type="card" style="">
				<el-tab-pane label="专业成绩" name="first">

				</el-tab-pane>
				<el-tab-pane label="文化成绩" name="second">

				</el-tab-pane>

				<el-tab-pane label="" name="third" disabled>
					<div slot="label">
						<div id="btnxlsbox" class="" style="text-align: left;">
							<el-button v-if="selectedStus.length>=0" @click="setStatusMore(1)" size="small"
								icon="el-icon-document-checked" type="">
								设为已通过
							</el-button>
							<el-button v-if="selectedStus.length>=0" @click="setStatusMore(-1)" size="small"
								icon="el-icon-document-delete" type="">
								设为未通过
							</el-button>
							<span style="font-size: 14px; color: orangered;">
								分数发布流程：请先将学生设置为【已通过】，然后点击 【检查通过列表】按钮再次核对无误后即可对外公开！
							</span>
						</div>
					</div>
				</el-tab-pane>


			</el-tabs>
		</el-row>

		<div v-if="activeName='first'">
			<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border size="mini"
				@sort-change="resortData" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" width="55" label="序号">
				</el-table-column>

				<el-table-column prop="exam_num" width="100" sortable label="准考证号">
				</el-table-column>
				<el-table-column prop="stu_name" label="姓名" width="80">

				</el-table-column>
				<el-table-column prop="gender" label="性别" sortable width="80">
					<template slot-scope="scope">

						<span v-if="scope.row.gender==1">男</span>
						<span v-if="scope.row.gender==2">女</span>

						<span v-if="scope.row.gender==0">未知</span>
					</template>
				</el-table-column>

				<el-table-column prop="gender" label="专业" min-width="120">
					<template slot-scope="scope">

						<span>{{scope.row.major_name}}</span> <span>{{scope.row.item_desc}}</span>

					</template>
				</el-table-column>






				<el-table-column prop="total_score" label="专业总分" sortable min-width="60">

				</el-table-column>
				<el-table-column prop="pjson" label="状态" min-width="60">
					<template slot-scope="scope">
						<span v-if="scope.row.confirm==1" style="color:green;">已通过</span>
						<span v-if="scope.row.confirm==-1" style="color:chocolate;">不通过</span>
						<span v-if="scope.row.is_pub===1" style="color:green;">已发布</span>
						<span v-if="scope.row.is_pub===0" style="color:chocolate;">未发布</span>
					</template>
				</el-table-column>

				<el-table-column fixed="right" label="操作" width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.is_pub!==null">
							<el-button type="text" v-if="!scope.row.confirm||scope.row.confirm==-1" size="small" @click="setPubStatus(scope.row,1)">通过</el-button>
							<el-button type="text" v-if="!scope.row.confirm||scope.row.confirm==1" size="small" style="color: orangered;"
								@click="setPubStatus(scope.row,-1)">不通过</el-button>
						</div>

					</template>
				</el-table-column>


			</el-table>
			<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
				:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
				layout="total, prev, pager, next, sizes, jumper">
			</el-pagination>

		</div>

		<el-dialog title="对外查询发布确认" :visible.sync="dialogVisible" width="1200px" top="2%" :close-on-click-modal="false">
			<div style="height: 80vh; position: relative;">
				<div style="position: absolute; top: -30px; width: 100%; color: dodgerblue;">
					<div style="width: 50%; float: right;">未通过列表
						
					</div>
					<div style="margin-right: 50%;">
						已通过列表

						<el-select v-model="searchForm.major_id" @change="checkList()" size="mini" placeholder="请选择"
							style="width: 150px; margin-right: 10px;">

							<el-option label="全部" value="">全部</el-option>
							<el-option v-for="(d,i) in majorList" :key="i" :label="d.title" :value="d.id"></el-option>

						</el-select>
						<el-button size="mini" icon="el-icon-s-promotion" style="margin-left: 100px;"
							@click="confirmPub" plain type="primary">对外发布</el-button>
					</div>
				</div>



				<div style="width: 50%; height: 100%; overflow: auto; display: inline-block; vertical-align: top;">
					<el-table stripe :data="tableData1" style="width: 100%;margin-bottom: 20px; color: #000;" border
						size="mini">
						<el-table-column prop="exam_num" width="100" label="准考证号">
						</el-table-column>
						<el-table-column prop="stu_name" label="姓名" width="80">
						</el-table-column>
						<el-table-column prop="gender" label="性别" width="60">
							<template slot-scope="scope">

								<span v-if="scope.row.gender==1">男</span>
								<span v-if="scope.row.gender==2">女</span>

								<span v-if="scope.row.gender==0">未知</span>
							</template>
						</el-table-column>

						<el-table-column prop="major_name" label="专业" min-width="120">

						</el-table-column>
						<el-table-column prop="total_score" label="专业总分" min-width="60">
						</el-table-column>
						<el-table-column prop="pjson" label="状态" min-width="60">
							<template slot-scope="scope">

								<span v-if="scope.row.is_pub===1" style="color:green;">已发布</span>
								<span v-if="scope.row.is_pub===0" style="color:chocolate;">未发布</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="width: 50%; height: 100%; overflow: auto; display: inline-block; vertical-align: top;">

					<el-table stripe :data="tableData0" style="width: 100%;margin-bottom: 20px; color: #000;" border
						size="mini">
						<el-table-column prop="exam_num" width="100" label="准考证号">
						</el-table-column>
						<el-table-column prop="stu_name" label="姓名" width="80">
						</el-table-column>
						<el-table-column prop="gender" label="性别" width="60">
							<template slot-scope="scope">

								<span v-if="scope.row.gender==1">男</span>
								<span v-if="scope.row.gender==2">女</span>

								<span v-if="scope.row.gender==0">未知</span>
							</template>
						</el-table-column>

						<el-table-column prop="major_name" label="专业" min-width="120">

						</el-table-column>
						<el-table-column prop="total_score" label="专业总分" min-width="60">
						</el-table-column>
						<el-table-column prop="pjson" label="状态" min-width="60">
							<template slot-scope="scope">

						
								<span v-if="scope.row.is_pub===1" style="color:green;">已发布</span>
								<span v-if="scope.row.is_pub===0" style="color:chocolate;">未发布</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-dialog>


	</div>
</template>
<script>
	export default {

		data() {
			return {
				activeName: "first",
				searchForm: {
					ktype: 'stu_name',
					orderby: " exam_num asc",
					is_pub: "",
					gender: "",
					score: "",
					major_id: 495
				}, //查询
				page: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 500, 1000],
					total: 0
				},
				majorList: [],
				selectedStus: [],
				dialogVisible: false,
				tableData:[],
				tableData0: [],
				tableData1: []
			}
		},


		mounted() {
			this.getList()
			this.getMajors()
			this.$nextTick(() => {

				$("#btnxlsbox").width($(window).width() - 500)
			})
		},
		methods: {
			getMajors() {

				this.$http.post("/api/sch_major_list").then(res => {
					this.majorList = res.data[0].children
				})
			},
			getList() {

				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					is_pub: this.searchForm.is_pub,
					confirm:this.searchForm.confirm,
					major_id: this.searchForm.major_id,
					gender: this.searchForm.gender,
					sp_status: "",
					score: 1
				}

				params.ktype = this.searchForm.ktype
				params.keyword = this.searchForm.keyword
				if (this.searchForm.orderby && this.searchForm.orderby.indexOf("gender") >= 0) {
					params.orderby = this.searchForm.orderby + " ,total_score desc "
				} else {
					params.orderby = this.searchForm.orderby
				}
				this.$http.post("/api/xjxy_score_students", params).then(res => {

					this.tableData = res.data.data
					this.page.total = res.data.page.count
					//this.st0Count = res.data.st0.st0
				})
				this.selectedStus = []
			},
			handlePageChange(e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleSizeChange(e) {
				this.page.pageSize = e
				this.getList()
			},
			resortData(e) {

				this.searchForm.orderby = e.prop + " " + (e.order == "ascending" ? 'asc' : 'desc')

				this.getList()
			},
			handleSelectionChange(e) {
				this.selectedStus = e
			},
			setStatusMore(t) {
				if (this.selectedStus.length > 0) {
					let okstus = [];
					for (let item of this.selectedStus) {
						if (item.confirm !== null && item.score_id) {
							if (item.confirm != t) {
								okstus.push(item.score_id)
							}
						}
					}
					if (okstus.length > 0) {
						let msg = t == 1 ? '确认设置为已通过？' : '确认设置为未通过'
						this.$confirm(msg, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$http.post("/api/xjxx_stu_score_pub_edit", {
								ids: okstus.join(","),
								confirm: t
							}).then(res => {
								this.$message({
									type: 'success',
									message: '设置成功!'
								});
								this.getList()
							})

						}).catch(() => {

						});
					} else {
						this.$message({
							type: 'error',
							message: '没有需要处理的数据!'
						});
					}
				} else {
					this.$message({
						type: 'error',
						message: '没有选中任何数据!'
					});
				}


			},
			setPubStatus(row, t) {
				let msg = t == 1 ? '确认设置为已通过？' : '确认设置为未通过'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/xjxx_stu_score_pub_edit", {
						ids: row.score_id,
						confirm: t
					}).then(res => {
						this.$message({
							type: 'success',
							message: '设置成功!'
						});
						this.getList()
					})

				}).catch(() => {

				});
			},
			checkList() {
				let params = {
					page: 1,
					pagesize: 10000,
					confirm: -1,
					major_id: this.searchForm.major_id,
					sp_status: "",
					score: 1,
					orderby: " exam_num asc"

				}

				this.$http.post("/api/xjxy_score_students", params).then(res => {

					this.tableData0 = res.data.data
					params.confirm = 1
					this.$http.post("/api/xjxy_score_students", params).then(res => {

						this.tableData1 = res.data.data

						this.dialogVisible = true
						this.$nextTick(() => {

							$("#loading").hide()
						})

					})
				})


			},
			confirmPub() {
				let ids = this.tableData1.map(e => {
					return e.score_id
				}).join(",")
				if (ids) {
					let msg = '确认对外发布？发布后学生可查询到成绩！'
					this.$confirm(msg, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.post("/api/xjxx_stu_score_pub_edit", {
							ids: ids,
							is_pub: 1
						}).then(res => {
							this.$message({
								type: 'success',
								message: '发布成功!'
							});
							this.checkList()
						})

					}).catch(() => {

					});
				}else{
					this.$message({
						type: 'error',
						message: '没有需要发布的数据!'
					});
				}
			}
		}
	}
</script>

<style lang="less" type="text/less">


</style>
